import BlogDetail from "../../../commonComponents/blogDetail";

const BlogVideoLayoutContainer = () => {
  return <BlogDetail type="video" />;
};

export default BlogVideoLayoutContainer;
